import { createFileRoute, redirect } from "@tanstack/react-router";
import Login from "../pages/Login";
import { getStoredTokens } from "../utils/auth";

export const Route = createFileRoute("/login")({
  beforeLoad: () => {
    const { accessToken } = getStoredTokens();
    if (accessToken) throw redirect({ to: "/" });
  },
  component: Login,
});
